export var generateRandomString = function generateRandomString(length) {
  var allowed = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var getRandomCharacter = function getRandomCharacter() {
    return allowed.charAt(Math.floor(Math.random() * allowed.length));
  };
  var chars = Array.from(Array(length), getRandomCharacter);
  return chars.join('');
};
export var toSentenceCase = function toSentenceCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};